import { AgGridReact } from '@ag-grid-community/react'
import GridActions from '@components/Base/GridActions/actions'
import { IReportDTO } from '@interfaces/report.interface'
import { Box, Typography } from '@mui/material'
import React from 'react'
export type IRVHeader = {
  reportData: IReportDTO
  gridReference: AgGridReact
}
const GFPAHeader: React.FC<IRVHeader> = ({ reportData, gridReference }) => {
  return (
    <Box display='grid' gridTemplateColumns='1fr auto' my={-2}>
      <Box display='flex' gap={1}>
        <Typography fontWeight={600}>Portfolio:</Typography>
        <Typography fontWeight={600}>{reportData.portfolioName}</Typography>
        {/*
        <Box display='flex' gap={1}>
          <Typography fontWeight={600}>Portfolio:</Typography>
          <Typography fontWeight={600}>{reportData.portfolioName}</Typography>
        </Box>
         <Divider orientation='vertical' />
        <Box display='flex' gap={1}>
          <Typography>Benchmark:</Typography>
          <Typography>{reportData.benchmarkName}</Typography>
        </Box>
        <Divider orientation='vertical' />
        <Box display='flex' gap={1}>
          <Typography>Report Date Range:</Typography>
          <Typography>
            {dayjs(reportData.beginDate).format(DATE_FORMAT.TABLE_CHART)} -{' '}
            {dayjs(reportData.endDate).format(DATE_FORMAT.TABLE_CHART)}
          </Typography>
        </Box>
        <Divider orientation='vertical' />
        <Box display='flex' gap={1}>
          <Typography>Report ID:</Typography>
          <Typography>{reportData.reportId}</Typography>
        </Box> */}
      </Box>
      <GridActions gridApiRef={gridReference} />
    </Box>
  )
}

export default GFPAHeader
